import { JSX, useMemo } from 'react'

import { NotificationPageLayout } from 'core-components/sitebuilder/common/NotificationPageLayout'

interface IEmptySitePage {
  footerContent?: () => JSX.Element
}

export const EmptySitePage = ({ footerContent }: IEmptySitePage) => {
  const description = useMemo(() => {
    return (
      <>
        It seems like you`ve encountered a digital Bermuda Triangle.
        <br /> Give our search a try or navigate back to our homepage to discover wealth of
        knowledge.
      </>
    )
  }, [])

  return (
    <NotificationPageLayout
      documentTitle={'Page not found'}
      headerText={'Whoopsie!'}
      headerDescriptionText={'Page not found'}
      description={description}
      footerContent={footerContent}
      imageLink={
        'https://res.cloudinary.com/appbuilder/image/upload/v1685524106/Images/page_not_found.png'
      }
    />
  )
}
